import { TagInput } from 'components/TagInput/TagInput'
import { CategoryDropdown } from '../CategoryDropDown/CategoryDropDown'
import { BlogMetadataCategoriesState, BlogMetadataCategoriesHandlers } from '../../../hooks/useBlogMetadataCategories'
import { BlogMetadataTagsState } from '../../../hooks/useBlogMetadataTags'
import Styles from '../../../BlogMetadata.module.scss'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface BlogMetadataCategoriesSectionProps {
  categoriesState: BlogMetadataCategoriesState
  categoriesHandlers: BlogMetadataCategoriesHandlers
  tagsState: BlogMetadataTagsState
  tagsHandlers: {
    handleTagsChange: (tags: string[]) => void
  }
  useCategoryDropdown?: boolean
  availableCategories?: string[]
  allowAddingCategories?: boolean
  addCategoryDisabledHint?: string
  hideCategories?: boolean
  maxCategories?: number
  maxTags?: number
  showCounters?: boolean
}

export const BlogMetadataCategoriesSection: React.FC<BlogMetadataCategoriesSectionProps> = ({
  categoriesState,
  categoriesHandlers,
  tagsState,
  tagsHandlers,
  useCategoryDropdown = false,
  availableCategories = [],
  allowAddingCategories = true,
  addCategoryDisabledHint,
  hideCategories = false,
  maxCategories,
  maxTags,
  showCounters = false,
}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { selectedCategories } = categoriesState
  const { handleCategoriesChange, handleCategoryDropdownClose } = categoriesHandlers
  const { tags } = tagsState
  const { handleTagsChange } = tagsHandlers

  const tagLimitError = maxTags && tags.length > maxTags ? `Maximum of ${maxTags} tags allowed` : undefined
  const categoryLimitError =
    maxCategories && selectedCategories.length > maxCategories
      ? `Maximum of ${maxCategories} categories allowed`
      : undefined

  return (
    <>
      {!hideCategories && (
        <div className={Styles.tagsContainer}>
          <label className={Styles.textFieldLabel}>
            Categories
            {showCounters && maxCategories && (
              <span className={Styles.counter}>
                {selectedCategories.length}/{maxCategories}
              </span>
            )}
          </label>
          {useCategoryDropdown ? (
            <div className={Styles.categoryDropdown}>
              <CategoryDropdown
                availableCategories={availableCategories}
                selectedCategories={selectedCategories}
                onCategoriesChange={handleCategoriesChange}
                onDropdownClose={handleCategoryDropdownClose}
                allowAddingCategories={allowAddingCategories}
                addCategoryDisabledHint={addCategoryDisabledHint}
                size={isSystemRedesignEnabled ? 'md' : 'lg'}
              />
            </div>
          ) : (
            <TagInput
              tags={selectedCategories}
              onChange={handleCategoriesChange}
              placeholder="Add a category"
              useAddPill
              size="md"
              wrapperClassName={Styles.blogTagInputContainer}
              inputWithBorder
              transparent
            />
          )}
          {categoryLimitError && <span className={Styles.limitError}>{categoryLimitError}</span>}
        </div>
      )}
      <div className={Styles.tagsContainer}>
        <label className={Styles.textFieldLabel}>
          Tags
          {showCounters && maxTags && (
            <span className={Styles.counter}>
              {tags.length}/{maxTags}
            </span>
          )}
        </label>
        <TagInput
          tags={tags}
          onChange={handleTagsChange}
          placeholder={'Add a tag'}
          useAddPill
          size="md"
          wrapperClassName={Styles.blogTagInputContainer}
          inputWithBorder
          transparent
        />
        {tagLimitError && <span className={Styles.limitError}>{tagLimitError}</span>}
      </div>
    </>
  )
}
